import React from 'react';
import SvgIcon from './SvgIcon';

const CaretDown = props => (
    <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
        <path
            d="M.872 5.628l11.126 12.575a.5.5 0 00.748 0L23.872 5.628"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CaretDown.displayName = 'CaretDownIcon';

export default CaretDown;
